import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { IsSessionExistsRequest } from '../../models/login/loginrequestmodel';
import { ApiResponseModel } from '../../models/api_response_model';
import { AppData } from '../../models/appdata';
import { LoginService } from '../../services/login.service';
import { Observable, Subscription, interval } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as alertFunctions from '../../../shared/data/sweet-alerts';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';

var fireRefreshEventOnWindow = function () {
  var evt = document.createEvent("HTMLEvents");
  evt.initEvent('resize', true, false);
  window.dispatchEvent(evt);
};
@Component({
  selector: 'app-testnurse',
  templateUrl: './testnurse.component.html',
  styleUrls: []
})
export class TestnurseComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void { }
  public ActorCode: number = 0;

  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;
  sub: Subscription;
  private _router: Subscription;
  constructor(private router: Router,
    private route: ActivatedRoute, private elementRef: ElementRef, private loginservice: LoginService) { }

  ngOnInit() {
    const elemMainPanel = <HTMLElement>document.querySelector('#gotopnurseapp');
    this._router = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      console.log('NavigationEnd');

      if (elemMainPanel) {
        console.log('gotopnurseadminapp');
        elemMainPanel.scrollIntoView();
      }
    });
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentIsSessionExistsRequest = new IsSessionExistsRequest();
    this.CurrentIsSessionExistsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.start();
  }
  onClick(event) {
    //initialize window resizer event on sidebar toggle click event
    setTimeout(() => { fireRefreshEventOnWindow() }, 300);
  }
  xIsSessionExists() {

    if (AppData.Instance().UserLoginDetails != null && AppData.Instance().UserLoginDetails.AuthGenKEY != null && AppData.Instance().UserLoginDetails.UserType == 3) {
      this.loginservice.xIsSessionExists(this.CurrentIsSessionExistsRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          // console.log(this.ApiResData.hasError)
          if (this.ApiResData.hasError) {
            this.sub.unsubscribe();
            if (AppData.Instance().IsSessionExits === true) {
              alertFunctions.AlertParam('Your Session Expired....!');
              AppData.Instance().IsSessionExits = false;
              this.router.navigate(['signinpage']);

            }

          }
          else {
            //console.log('Session Check ...!');
            if (localStorage.length > 0 && AppData.Instance().UserLoginDetails.UserName != localStorage.getItem("UserName")) {
              this.sub.unsubscribe();
              if (AppData.Instance().IsSessionExits === true) {
                AppData.Instance().IsSessionExits = false;
                this.router.navigate(['signinpage']);;
                alertFunctions.AlertParam('Another User is Loged In Same Browser....!');
              }

            }
            else {

            }


          }

        },


          (error) => {

            // alertFunctions.AlertParamEr(error);
            this.sub.unsubscribe();
          }


        );
    }
    else {
      //this.router.navigate(['signinpage']);
      this.sub.unsubscribe();
      //  console.log('--->' + AppData.Instance().UserLoginDetails.AuthGenKEY);

    }

  }
  start() {
    // setInterval(() => {
    //   this.xIsSessionExists()
    //}, 5000);
    this.sub = interval(15000)
      .subscribe((val) => { this.xIsSessionExists(); });

  }
}
